import { apiClient, getHeaders } from '@/services/axiosConfig'
export default {
  showPartner (auth, payload) {
    return apiClient({
      method: 'get',
      url: 'v1/stores/' + payload.id,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getPartners (auth, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/stores',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getNearestPartners (auth, payload) {
    return apiClient({
      method: 'get',
      url: 'v1/stores/around-you',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getRelatedPartners (auth, payload) {
    return apiClient({
      method: 'post',
      url: `v1/stores/${payload.partnerId}/related-stores`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getRelatedPartnersNew (auth, payload) {
    return apiClient({
      method: 'get',
      url: `v1/stores/${payload.partnerId}/related-stores`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getRelatedBranches (auth, payload) {
    return apiClient({
      method: 'get',
      url: `v1/stores/${payload.partnerId}/branches`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getProductRecommendations (auth, id, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/stores/' + id + '/recommended-products',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getShowcasePartner (auth, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/showcases/store-profile',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  }
}
